<template lang="html">
  <div class="profile-my-sellers-wrapper">
    <div class="actions-wrapper">
      <!-- <span>{{$t('profile.links.mySellers')}}</span> -->
      <dropdown
        :defaultText="$t('dropdown.sort')"
        :selected="sortSelected"
        :list="sortList"
        :removable="true"
        @remove="(sortSelected = null), getSellers()"
        @changeOption="(sortSelected = $event), getSellers()"
      />
      <div class="search-wrapper">
        <InputView
          @input="(page = 1), getSellers()"
          v-model="search"
          type="text"
          icon="mdi:search"
          :label="$t('nav.search')"
        />
      </div>
    </div>
    <table>
      <thead>
        <tr>
          <td>{{ $t("profile.buyers.sellerName") }}</td>
          <td style="width: 40px"></td>
          <td style="width: 40px"></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="seller in sellers" :key="seller.usr_id">
          <td>
            {{ seller.usr_name }}
          </td>
          <td @click="openChatModal(seller)">
            <div class="icon-wrapper">
              <img
                :title="$t('main.sendMessage')"
                src="@/assets/icons/message.svg"
                alt="message icon"
              />
            </div>
          </td>
          <td @click="openSellerHistoryModal(seller)">
            <div class="icon-wrapper">
              <img
                :title="$t('main.moreInfo')"
                src="@/assets/icons/options.png"
                alt="preview icon"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="sellers.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
import Dropdown from "@/components/dropdown.vue";
import TestInput from "../shared/testInput.vue";
export default {
  name: "profileMySellers",
  components: {
    Dropdown,
    InputView: TestInput
  },
  data() {
    return {
      sellers: [],
      page: 1,
      pageCount: 0,
      search: null,
      sortSelected: null
    };
  },
  mounted() {
    this.getSellers();
  },
  methods: {
    openSellerHistoryModal(user) {
      let params = {
        modalData: user,
        component: "mySellersSellerHistory"
      };
      eventBus.$emit("openModal", params);
    },
    openChatModal(user) {
      let params = {
        modalData: user,
        component: "messageModal"
      };
      eventBus.$emit("openModal", params);
    },
    getSellers() {
      let params = {
        page: this.page
      };
      if (this.sortSelected) {
        params.sort = this.sortSelected.value;
      }
      if (this.search && this.search !== "") {
        params.search = this.search;
      }
      api
        .getSellers(params)
        .then(res => {
          this.sellers = res.data.data;
          this.pageCount = res.data.page_count;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getPaginationImages(side) {
      let path = require(`@/assets/icons/pagination${side}.png`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
      this.sellers = [];
      this.getSellers();
    }
  },
  computed: {
    sortList() {
      return [
        {
          label: this.$t("profile.sellers.rejected"),
          value: "rejected"
        },
        {
          label: this.$t("profile.sellers.gave-up"),
          value: "gave-up"
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-my-sellers-wrapper {
  padding-left: 40px;
  .actions-wrapper {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    span {
      font-weight: bold;
      font-size: 21px;
      line-height: 34px;
      letter-spacing: 0.06em;
    }

    .search-wrapper {
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      input {
        border: none;
        border-bottom: 1px solid #ddd;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        height: 20px;
        line-height: 20px;
        padding-right: 20px;
        font-weight: bold;
        font-size: 13px;
        line-height: 15px;
        letter-spacing: 0.02em;
        color: $text-color;
        max-width: 230px;
      }
      input::placeholder {
        font-weight: bold;
        font-size: 13px;
        letter-spacing: 0.04em;
        color: $text-color;
      }
      input:focus {
        outline: none;
      }
      img {
        position: absolute;
        right: 0;
        cursor: pointer;
      }
    }
  }
}
@import "@/assets/scss/tableStyles.scss";
.icon-wrapper img {
  height: 20px;
}
@media screen and (max-width: 1000px) {
  .profile-my-sellers-wrapper {
    padding: 0px;
  }
}
</style>
